import React from 'react'

export const emptyFieldStyle: React.CSSProperties = {
  borderLeft: '3px solid #ffc107',
  paddingLeft: '10px',
}

export function NotFilledBadge({ label }: { label: string }) {
  return (
    <span
      className="ml-2"
      style={{
        display: 'inline-block',
        padding: '1px 7px',
        fontSize: '0.7rem',
        fontWeight: 500,
        lineHeight: '1.6',
        borderRadius: '4px',
        backgroundColor: '#fff3cd',
        color: '#856404',
        border: '1px solid #ffc107',
        verticalAlign: 'middle',
      }}
    >
      {label}
    </span>
  )
}
